import { IconSize } from './Icon.types';

export const ICON_SIZE_IN_PX = {
  [IconSize.XS]: '12px',
  [IconSize.S]: '16px',
  [IconSize.M]: '20px',
  [IconSize.L]: '24px',
  [IconSize.XL]: '32px',
};
